import {
    FormControl,
    Grid,
    InputLabel,
    Select,
    TextField,
    MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect } from "react";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import {
    adderCategoriesReset,
    CreateAdderCategoriesMethod
} from "../../Redux/AddersCategoriesSlice/AddersCategoriesSlice";

const CreateAdderCategory = () => {
    const dispatch = useDispatch();
    const { isLoading, isSuccess, isError, errors } = useSelector(
        (state) => state.adders_categories
    );

    const allGroupsTypes = [
        { name: "dropdown" },
        { name: "checkbox" },
        { name: "radio" },
    ];

    const validationSchema = yup.object({});
    const formik = useFormik({
        initialValues: {
            name: "",
            type: "",
            submit: false,
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values.submit = true;
            await dispatch(CreateAdderCategoriesMethod(values));
            await dispatch(adderCategoriesReset());
        },
    });

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(adderCategoriesReset());
            };
            reset();
        }
    }, [dispatch, errors, isError]);

    useEffect(() => {
        if (isSuccess && formik.values.submit) {
            toast.success("Group Created successfully");
            formik.values.name = "";
        }
    }, [formik.values, isSuccess]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Add New Group </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                        Type
                                    </InputLabel>
                                    <Select
                                        id="type"
                                        name="type"
                                        label="Type"
                                        value={formik.values.type}
                                        onChange={formik.handleChange}
                                    >
                                        {allGroupsTypes?.map((key, index) => (
                                            <MenuItem
                                                key={index}
                                                value={key.name}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Add New Group"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateAdderCategory;
